/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import api from "./api";

// ── Subscription Tiers ──────────────────────────────────────────────────
/** List all active subscription tiers with their feature entitlements. */
export const getSubscriptionTiers = () =>
  api.get("/subscriptions/tiers/");

/** List active trial offerings for signup. Public endpoint; auth token optional. */
export const getActiveTrialSubscriptions = () =>
  api.get("/subscriptions/trials/active/");

// ── My Subscription ─────────────────────────────────────────────────────
/** Get the current user's active subscription. */
export const getMySubscription = () =>
  api.get("/subscriptions/me/subscription");

/** Get the current user's effective access snapshot for frontend gating. */
export const getMyAccess = () =>
  api.get("/subscriptions/me/access");

// ── My Usage ────────────────────────────────────────────────────────────
/** Get quota-metered feature usage for the current user's tier. */
export const getMyUsage = () =>
  api.get("/subscriptions/me/usage");

// ── Change Subscription ─────────────────────────────────────────────────
/**
 * Change the user's subscription tier.
 * @param {string} tierCode - The tier code to switch to.
 * @param {string|null} paymentIntentId - UUID of a completed payment (for paid tiers).
 */
export const changeSubscription = (tierCode, paymentIntentId = null) =>
  api.post("/subscriptions/me/change/", {
    tier_code: tierCode,
    payment_intent_id: paymentIntentId,
  });

// ── Cancel Subscription ─────────────────────────────────────────────────
/**
 * Cancel the current user's subscription.
 * @param {string} reason - Optional cancellation reason.
 */
export const cancelSubscription = (reason = "") =>
  api.post("/subscriptions/me/cancel/", { reason });
